module.exports = __webpack_public_path__ + "static/media/program_step_2_fr.f6d81294.svg";